module.exports = __webpack_public_path__ + "static/7i-89874573d9b2380672f3c5685263f6c4.woff";